
export {alignElement,
alignPoint} from '../../../frontend-js-dependencies-web/__liferay__/exports/dom-align.js';
import __x__ from '../../../frontend-js-dependencies-web/__liferay__/exports/dom-align.js';export default __x__;